import { defineMessages, FormattedMessage, useIntl } from 'react-intl'
import get from 'lodash/get'
import { Fragment, useState } from 'react'
import styles from '../AdventureCardDsl.module.scss'
import cx from 'classnames'
import {
  getProductCategory,
  openSalesForcePopup,
} from '../../dive-guides/gtm-events'
import PriceConverter from '../../helpers/PriceConverter'
import InstantConfirmation from '../../adventures/InstantConfirmation'
import { pushToDataLayer } from 'gtm'
import { target } from '../../../utils'
import PicPreview from '../../liveaboard/PicPreview'

const messages = defineMessages({
  elearning: {
    id: 'elearning_card_price',
    defaultMessage: 'Buy eLearning',
  },
  adventure: {
    id: 'activity_card_price',
    defaultMessage: 'Book Now',
  },
  viewDetails: {
    id: 'paper_card_view_details',
    defaultMessage: 'View Details',
  },
  contactShop: {
    id: 'paper_card_contact_shop',
    defaultMessage: 'Contact Shop',
  },
})

const CardPrice = ({
  adventure,
  isWidget,
  type,
  isCourse,
  activityPage,
  externalPage,
  isBlocked,
  wechatQr
}) => {
  const intl = useIntl()
  const price =
    type === 'elearning'
      ? get(adventure, 'price.targetValue')
      : get(adventure, 'minimumPrice.targetValue')
  const currency =
    type === 'elearning'
      ? get(adventure, 'price.targetCurrency')
      : get(adventure, 'minimumPrice.targetCurrency')
  const compareAtPrice = get(adventure, 'compareAtPrice.targetValue')
  const prevQueryParams = window.location.search
    ? window.location.search.replace('?', '&')
    : ''
  const activityLink = `${activityPage}${
    isWidget ? `${prevQueryParams}&widget=true` : prevQueryParams
  }`
  const [isOpenQr, setOpenQrStatus] = useState(false)

  const trackGtmEvent = () => {
    pushToDataLayer({
      event: 'interaction',
      eventCategory: 'Dive Shop',
      eventAction: isCourse
        ? 'PADI - eLearning Click'
        : 'PADI - PADI Travel Click (Listing)',
      eventLabel: window.shopInfo.affiliateId,
      eventValue: '0',
      eventNonInteraction: 'false',
    })

    const activityCategory = isCourse
      ? 'Courses'
      : getProductCategory(adventure.activityType).activityType
    pushToDataLayer({
      event: 'productClick',
      eventCategory: 'Dive Shop',
      eventAction: 'PADI - Activity Click',
      eventLabel: `${activityCategory} - ${adventure.title} - ${window.shopInfo.affiliateId}`,
      ecommerce: {
        currencyCode: currency,
        click: {
          products: [
            {
              name: adventure.title,
              id: adventure.id || adventure.activityId,
              price: price,
              brand: 'PADI',
              category: activityCategory,
              position: adventure.position,
            },
          ],
        },
      },
    })
  }

  const onContactShop = () => {
    if(wechatQr) {
      setOpenQrStatus(true)
      return
    }
    openSalesForcePopup(window.shopInfo, intl, false, false)
  }

  const paperPrice = (
    <Fragment>
      <div className={cx(styles.paperLink, styles.pricingSection)}>
        <a
          href={externalPage || activityLink}
          onClick={trackGtmEvent}
          target='_blank'
          className='link'
        >
          <FormattedMessage {...messages.viewDetails} />
        </a>
      </div>
      <button
        className={cx(styles.dslButton, 'dsl-btn-blue-invert')}
        onClick={onContactShop}
      >
        <FormattedMessage {...messages.contactShop} />
      </button>
    </Fragment>
  )

  const adventurePrice = (
    <Fragment>
      <div className={cx(styles.pricingSection)}>
        {adventure.instantConfirmation && <InstantConfirmation isDsl />}
        {/* <span */}
        {/*   className={cx(styles.priceFrom, { [styles.show]: isOtherActivity })} */}
        {/* > */}
        {/*   <FormattedMessage id='price_from_adventure' defaultMessage='from' /> */}
        {/* </span> */}
        <span className={cx('pricing', styles.pricing)}>
          {compareAtPrice > price && (
            <span className={styles.oldPricing}>
              <PriceConverter
                amount={compareAtPrice}
                currency={currency}
                to={currency}
                conversionPercent
              />
            </span>
          )}
          <PriceConverter amount={price} currency={currency} to={currency} />
        </span>
      </div>
      <a
        href={externalPage || activityLink}
        target={isWidget && type === 'adventure' ? '_self' : target}
        className={cx(styles.dslButton, {
          'dsl-btn-blue': type !== 'adventure',
          'btn-red': type === 'adventure',
        })}
        onClick={trackGtmEvent}
      >
        <FormattedMessage {...messages[type]} />
      </a>
    </Fragment>
  )
  if(isBlocked) {
    return null
  }
  return <>
    <div className={cx(styles.price)}>
      {type === 'paper' ? paperPrice : adventurePrice}
    </div>
    {isOpenQr && <PicPreview photo={`${window.location.origin}${wechatQr}`} setStatus={setOpenQrStatus} />}
  </>
}

export default CardPrice
